var jBody = $('body');
jBody.on('click', 'a[data-confirm],button[data-confirm]', function (e) {//a confirm
    var r = confirm($(this).data("confirm"));
    if (r !== true) {
        e.preventDefault();
    } else {
        $(this).trigger('click-confirmed', e);
    }
});

$(document).on('submit', 'form[data-confirm]', function (e) {
    var r = confirm($(this).data("confirm"));
    if (r !== true) {
        e.preventDefault();
    }
})

// Custom confirmation modal
jBody.on('click', 'a[data-confirm-modal]', function (e, confirmed) {
    if (confirmed === true) {
        return true;
    }
    let currentBtn = e.target;
    let $link = $(this);
    let classN = $link.data('class') || ''

    global.openConfirmModal({
        title: $link.data('confirm-modal'),
        ok: {
            title: $link.data('btn-ok'),
            link: $link.data('src'),
            callback: function (){
                $(currentBtn).removeAttr('data-confirm-modal');
                $(currentBtn).addClass(classN);
                $(currentBtn).trigger('click');
            }
        },
        cancel: {}
    })

    return false;
});


/*
global.openConfirmModalOld = function (title, okText, href, action, classN, callback){

    let hrefAttr = (href) ? ' href="' + href + '"' : '';
    let actionAttr = (action) ? ' data-action="' + action + '"' : '';

    let dataAttr = '', className = '';

    var modalHtml =
        '<div class="modal fade modal-ajax-form" tabindex="-1" aria-hidden="true" data-bs-keyboard="false" data-bs-backdrop="static">'
        + '<div class="modal-dialog modal-dialog-centered">'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>'
        + '</div>'
        + '<div class="modal-body">'
        + '<img src="/Project/Modules/General/Admin/assets/images/icons/icon-info.svg"/>'
        + '<h5 class="modal-title">' + title + '</h5>'
        + '</div>'
        + '<div class="modal-footer py-3">'
        + '<a' + hrefAttr + ' class="btn btn-primary btn-href' + ((!href) ? ' d-none' : className) + '"' + dataAttr + '>'
        + (okText || 'OK') + '</a>'
        + '<a' + actionAttr + ' data-bs-dismiss="modal" aria-label="Close"  class="btn btn-action btn-primary  ' + classN + '' + ((!action) ? ' d-none' : className) + '"' + actionAttr + '>'
        + (okText || 'OK') + '</a>'
        + '<button type="button" class="btn btn-primary close-modal" data-bs-dismiss="modal" aria-label="Close">Uždaryti</button>'
        + '</div>'
        + '</div>'
        + '</div>'
        + '</div>';

    let $modal = $(modalHtml);


    $('body').append($modal);

    let modal_inst = new bootstrap.Modal($modal);
    modal_inst.show();

    $modal.modal({}).on('hidden.bs.modal', function () {
        $modal.remove();
    });
    $modal.on("click", ".btn-action", function () {
        callback()
    });

}
*/